import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParagraphComponent } from './paragraph.component';

@NgModule({
  imports: [CommonModule, MatIconModule, SharedModule, ParagraphComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoParagraphComponent: {
          component: ParagraphComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class ParagraphModule {}
